import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { createColumnHelper } from "@tanstack/react-table";
import { useCompanyDateFormat, useCompanyTimeFormat } from "../../../../../utils/hooks/company";
import { dateTimeFormat } from "../../../../../utils/helpers/date";
import { firstToUpper } from "../../../../../utils/helpers/string";
import HistoryTooltip from "./HistoryTooltip";

const columnHelper = createColumnHelper();

export const useColumns = () => {
    const { t } = useTranslation();
    const dateFormat = useCompanyDateFormat();
    const timeFormat = useCompanyTimeFormat();

    return useMemo(
        () => [
            columnHelper.accessor("createdAt", {
                header: t("date"),
                cell: (info) => {
                    const value = info.getValue();
                    return (
                        value && (
                            <span>
                                {dateTimeFormat(value, dateFormat)} - {dateTimeFormat(value, timeFormat)}
                            </span>
                        )
                    );
                },
            }),
            columnHelper.accessor("entityData.code", {
                header: t("code"),
                cell: (info) => {
                    const value = info.getValue();
                    return value;
                },
            }),
            columnHelper.accessor("entityData.description", {
                header: t("description"),
                cell: (info) => {
                    const value = info.getValue();
                    return value;
                },
            }),
            columnHelper.accessor("updatedBy", {
                header: t("user"),
                cell: (info) => {
                    const value = info.getValue();
                    return value && value.full_name;
                },
            }),
            columnHelper.accessor("data", {
                header: t("changes"),
                cell: ({ row }) => <HistoryTooltip row={row} />,
            }),
            columnHelper.accessor("action", {
                header: t("action"),
                cell: (info) => {
                    const value = info.getValue();
                    return firstToUpper(value || "");
                },
            }),
        ],
        [dateFormat, timeFormat, t]
    );
};
